/* eslint-disable camelcase */
export class Rules {
  constructor(creationConstraints, previewDimensions, disallowedOperations) {
    this.creationConstraints = creationConstraints || {};
    this.previewDimensions = previewDimensions || {};
    this.disallowedOperations = disallowedOperations || {};
  }

  static toInstance(props = {}) {
    return new Rules(props.creation_constraints, props.preview_dimensions, props.disallowed_operations,);
  }
}
